import { Inventary } from "../Models/Inventary";
import { PokemonCard } from "../Models/PokemonCard";
import { PokemonSet } from "../Models/PokemonSet";
import { ResponseContent } from "../Models/ResponseContent";
import { deleteApi, getApi, patchApi, postApi } from './Api';


export const getAllCardsInventary = async () => {
    try{
        return await getApi<{products:Inventary[], last_page:number, page:number, total:number}>('inventories/get-products')
    }
    catch(error){
        throw error;
    }
}

export const getAllCardsInventaryPublic = async (page?:number, limit?:number, cardName?:string, setID?:string, rarity?:string) => {
    try{
        return await getApi<{products:Inventary[], last_page:number, page:number, total:number}>(`inventories/get-products-public?page=${page || 1}&limit=${limit || 10}&cardName=${cardName || ""}&sets=${setID || ""}&rarity=${rarity || ""}`)
    }
    catch(error){
        throw error;
    }
}

export const getAllCards = async (name:string, setID:string) => {
    try{
        return await getApi<PokemonCard[]>(`pokemon-cards/allCards?card_name=${name}&set_id=${setID}`)
    }
    catch(error){
        throw error;
    }
}

export const getAllPokemonSets = async () => {
    try{
        return await getApi<PokemonSet[]>(`pokemon-sets/allSets`)
    }
    catch(error){
        throw error;
    }
}

export const addCardToIventary = async (obj:any, quantity:number) => {
    try{
        return await postApi<ResponseContent>(`inventories/add-product?quantity=${quantity}`, obj)
    }
    catch(error){
        throw error;
    }
}

export const updateInventaryCard = async (id:string, price:number, quantity:number) => {
    try{
        return await patchApi<ResponseContent>(`inventories/update-product?card_id=${id}&price=${price}&quantity=${quantity}`, {})
    }
    catch(error){
        throw error;
    }
}

export const deleteInventaryCard = async (id:string) => {
    try{
        return await deleteApi<ResponseContent>(`inventories/delete-product?card_id=${id}`)
    }
    catch(error){
        throw error;
    }
}